import { useState, useCallback, useEffect, ChangeEvent } from "react";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import { useCustomers } from "../../../app/hooks/useCustomers";
import { useDebounce } from "../../../app/hooks/useDebounce";

export const useCustomerController = () => {
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchValue = useDebounce(500, searchValue);
  const { ref, inView } = useInView();
  const navigate = useNavigate();

  const handleCustomerDetailsPage = (id: string) => {
    navigate(`/clientes/${id}`);
  };

  const {
    data,
    isFetching,
    isLoading,
    setParams,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCustomers({ initialLimit: 30 });

  const setSkip = useCallback(
    (value: number) => {
      setParams((state) => ({ ...state, skip: value }));
    },
    [setParams],
  );
  const setSearch = useCallback(() => {
    setParams((state) => ({ ...state, search: debouncedSearchValue }));
  }, [debouncedSearchValue, setParams]);

  useEffect(() => {
    setSearch();
  }, [setSearch]);

  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView]);

  return {
    handleCustomerDetailsPage,
    setSkip,
    data,
    isFetching,
    isLoading,
    searchValue,
    handleSearchInputChange,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    ref,
  };
};
